import { createSlice } from '@reduxjs/toolkit';
import { StorageStateType } from 'src/types/storage';

const initialState: StorageStateType = {
    data: {},
};

export const storageSlice = createSlice({
    name: 'storage',
    initialState,
    reducers: {
        setStorageData: (state, action: { payload: { key: string; data: any } }) => {
            state.data[action.payload.key] = action.payload.data;
        },
    },
});

export const { setStorageData } = storageSlice.actions;

export default storageSlice.reducer;
